import { ChevronIcon } from "components/ui/customWebviewer/ElevationReferencesSidebar/icons/ChevronIcon"
import style from "./PrevNextNav.module.scss"

type Props = {
	onPrev: () => void
	onNext: () => void
	disabled?: boolean
	prevAriaLabel?: string
	nextAriaLabel?: string
}

export const PrevNextNav = ({
	onPrev,
	onNext,
	disabled = false,
	prevAriaLabel = "Previous",
	nextAriaLabel = "Next",
}: Props) => {
	return (
		<div className={style.nav}>
			<button
				type="button"
				className={style.button}
				onClick={onNext}
				disabled={disabled}
				aria-label={nextAriaLabel}
			>
				<ChevronIcon direction="down" />
			</button>
			<span className={style.divider} aria-hidden="true" />
			<button
				type="button"
				className={style.button}
				onClick={onPrev}
				disabled={disabled}
				aria-label={prevAriaLabel}
			>
				<ChevronIcon direction="up" />
			</button>
		</div>
	)
}
